import { createContext, useContext } from "react";

import { Dayjs } from "dayjs";

const WeekHoverContext = createContext<{
  hover: Dayjs | null;
  setHover: (d: Dayjs | null) => void;
}>({
  hover: null,
  setHover: () => {},
});

export const useWeekHover = () => useContext(WeekHoverContext);
export default WeekHoverContext;
